export class Profile{
    public coverFirstName:string;
    public coverLastName:string;
    public hometownCity:string;
    public hometownCountry:string;
    public missionDate:string;
    public occupation:string;
    public codeword:string;
    public mission:string;
}